export default __webpack_public_path__ + "static/media/full-logo.d7d47358.svg";